import { MapContainer, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";

const icon = L.divIcon({
  html: '<span class="marker-dot" style="background:#65a30d"></span>',
  className: "pointer-events-none",
  iconSize: [24, 24]
});

const SingleMarkerMap = ({ position, className = "" }) => (
  <MapContainer
    center={position}
    zoom={4}
    className={`h-64 w-full rounded-3xl border border-brand-ink/40 ${className}`}
    scrollWheelZoom={false}
  >
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <Marker position={position} icon={icon} />
  </MapContainer>
);

export default SingleMarkerMap;
